import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Alert,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Grid,
  Paper,
  Snackbar,
  TextField,
  Typography,
} from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { forgotPassword } from '../../services/api'
import { mensagemDeErro } from '../../services/apiClient'
import bgImage from '../../assets/login.png'
import bihands from '../../assets/Ativo-3@4x-bihands-300x64.png'

const ForgotPassword = () => {
  const navigate = useNavigate()

  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [feedback, setFeedback] = useState({ open: false, message: '', severity: 'success' })

  const handleSubmit = async event => {
    event.preventDefault()
    if (!email) {
      setFeedback({ open: true, message: 'Insira seu e-mail', severity: 'error' })
      return
    }

    setLoading(true)
    try {
      await forgotPassword({ email })
      setFeedback({
        open: true,
        message: 'Enviamos as instruções de redefinição para o seu e-mail.',
        severity: 'success',
      })
      setEmail('')
    } catch (err) {
      setFeedback({
        open: true,
        message: mensagemDeErro(
          err,
          err.message || 'Não foi possível enviar o e-mail de redefinição. Tente novamente.'
        ),
        severity: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  const form = (
    <Box sx={{ width: '90%', textAlign: 'center' }} component="form" onSubmit={handleSubmit}>
      <Box my={2}>
        <Box component="img" src={bihands} alt="Bihands" sx={{ width: '100%', maxWidth: 350 }} />
      </Box>
      <Typography variant="h6">Recuperar senha</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1, mb: 2 }}>
        Informe o e-mail cadastrado e enviaremos as instruções para redefinir sua senha.
      </Typography>

      <TextField
        margin="normal"
        required
        fullWidth
        id="email"
        name="email"
        label="E-mail"
        type="email"
        autoComplete="email"
        autoFocus
        value={email}
        onChange={event => setEmail(event.target.value)}
      />

      <Button type="submit" variant="contained" sx={{ mt: 2 }} disabled={loading}>
        Enviar instruções
      </Button>
      <Button startIcon={<ArrowBackIcon />} sx={{ mt: 2, fontSize: '.8em' }} onClick={() => navigate('/Login')}>
        Voltar para o login
      </Button>
    </Box>
  )

  return (
    <Grid
      container
      component="main"
      sx={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={feedback.open}
        autoHideDuration={6000}
        onClose={() => setFeedback(current => ({ ...current, open: false }))}
      >
        <Alert
          onClose={() => setFeedback(current => ({ ...current, open: false }))}
          severity={feedback.severity}
          sx={{ width: '100%' }}
        >
          {feedback.message}
        </Alert>
      </Snackbar>

      <Box
        display={{ xs: 'none', md: 'flex' }}
        sx={{ width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center' }}
      >
        <Box
          sx={{
            width: '65%',
            height: '100vh',
            backgroundImage: `url(${bgImage})`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center center',
          }}
        />
        <Box
          sx={{
            width: '35%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {form}
        </Box>
      </Box>

      <Box
        display={{ xs: 'flex', md: 'none' }}
        sx={{
          width: '100%',
          height: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            width: '90%',
            padding: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          {form}
        </Paper>
      </Box>

      <Backdrop sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Grid>
  )
}

export default ForgotPassword
